import { useMemo } from 'react';
import { useCollaborationStore } from '@/store/collaborationStore';
import type { CollaboratorAwareness } from '@/collaboration/awareness';

/** Maximum number of avatar circles to display before showing a "+N" badge. */
const MAX_VISIBLE = 3;

function getInitials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 0 || !parts[0]) return '?';
  if (parts.length === 1) return parts[0]!.charAt(0).toUpperCase();
  return (parts[0]!.charAt(0) + parts[parts.length - 1]!.charAt(0)).toUpperCase();
}

export function CollaboratorList() {
  const collaborators = useCollaborationStore((s) => s.collaborators);

  const collabArray = useMemo<CollaboratorAwareness[]>(
    () => Array.from(collaborators.values()),
    [collaborators],
  );

  if (collabArray.length === 0) {
    return (
      <span style={{ fontSize: 12, color: '#94a3b8', fontFamily: 'system-ui, sans-serif' }}>
        Only you
      </span>
    );
  }

  const visible = collabArray.slice(0, MAX_VISIBLE);
  const overflow = collabArray.length - MAX_VISIBLE;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
      }}
    >
      {visible.map((c) => (
        <div
          key={c.userId}
          title={c.name}
          style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            backgroundColor: c.color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 11,
            fontWeight: 600,
            fontFamily: 'system-ui, sans-serif',
            color: '#fff',
            cursor: 'default',
            flexShrink: 0,
          }}
        >
          {getInitials(c.name)}
        </div>
      ))}
      {overflow > 0 && (
        <div
          style={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            backgroundColor: '#334155',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 11,
            fontWeight: 600,
            fontFamily: 'system-ui, sans-serif',
            color: '#cbd5e1',
            cursor: 'default',
            flexShrink: 0,
          }}
        >
          +{overflow}
        </div>
      )}
    </div>
  );
}
